import { useEffect, useState } from "react";

import {
  PaymentsPayinService,
  type PayinRuntimeEntity,
} from "@/modules/dashboard/payins/services/paymentsPayin.service";

export interface UseStatementPayinResult {
  payin: PayinRuntimeEntity | null;
  isLoading: boolean;
}

interface PayinRead {
  id: string;
  payin: PayinRuntimeEntity | null;
}

// A failed read leaves `payin` null and the caller falls back to the leg's own amount.
export function useStatementPayin(payinId: string | null): UseStatementPayinResult {
  const [read, setRead] = useState<PayinRead | null>(null);

  useEffect(() => {
    if (!payinId) return;
    let cancelled = false;
    PaymentsPayinService.getPayin(payinId)
      .then(({ data }) => {
        if (!cancelled) setRead({ id: payinId, payin: data });
      })
      .catch(() => {
        if (!cancelled) setRead({ id: payinId, payin: null });
      });
    return () => {
      cancelled = true;
    };
  }, [payinId]);

  if (!payinId) return { payin: null, isLoading: false };
  if (read?.id !== payinId) return { payin: null, isLoading: true };
  return { payin: read.payin, isLoading: false };
}
